<template>
  <!--带左侧导航和头部-->
  <div v-if="!isAbsolute" class="tms-frame">
    <Header v-show="!isAbsolute" :sideBarShow.sync="sideBarShow"/>
    <sidebar :class="classObj" class="sidebar-container" :sideBarShow="sideBarShow" v-show="sideBarShow" />
    <div id="TMS_mainContainer" :class="{allwidth: !sideBarShow, 'main-container': !isAbsolute}">
      <AppMain :iframeShowUrl="iframeShowUrl"></AppMain>
    </div>
  </div>
  <!--独立访问-->
  <router-view  v-else/>
</template>

<script>
  import { mapState } from 'vuex'
  import { Header, Sidebar, AppMain } from './components'
  import Bus from './eventBus.js'
  import SystemManage from '../../../api/TMS/SystemManage'

  export default {
    data() {
      return {
        isAbsolute: /\/micro-container/.test(location.href) == true, // 是否独立访问，不渲染 左侧和顶部
        sideBarShow: true,
        iframeShowUrl: false,
      }
    },
    components: {
      Header,
      Sidebar,
      AppMain
    },
    created() {
      this.getWebVersion()
      this.sideBarShowFun()
      this.getButtonsAccess()
    },
    computed: mapState({
      cIsTms: function() {
        return window.location.href.indexOf('sysCode=club') != -1 ? 'club' : 'portal'
      },
      sidebar() {
      },
      classObj() {
        return {
        }
      }

    }),
    props: {
      defaultURL: {
        type: String,
        default: ''
      }
    },
    watch: {},
    methods: {
      // 获取按钮权限，并存储给vuex
      async getButtonsAccess() {
        let reqData = {
          code: this.cIsTms,
        }
        let resData = await SystemManage.getUserAccessButton(reqData)
        this.$store.commit('accessButtons', resData.codes)
        this.$store.commit('accessButtonsState', true)
      },
      sideBarShowFun() {
        const that = this
        Bus.$on('iframeShowUrl', function(bool) {
          that.iframeShowUrl = bool
        })
      },
      // 版本更新刷新页面
      async getWebVersion() {
        // const resData = await ApiNode.Common.getWebVersion()
        // if (localStorage.WebVersion != resData) {
        //   localStorage.WebVersion = resData
        //   window.location.reload(true)
        // }
      }
    }
  }
</script>

<style lang="less" >
  @import "../layout_common.less";
  #eosWeb{
    height: 100%;
    .tms-frame{
      height: 100%;
      overflow: hidden;
      // 主体区域
      .main-container {
        overflow-y: auto;
        height: auto;// 修改时，查看二师局长信箱-写信须知样式  calc(100vh - 50px);
        min-height: calc(100vh - 50px);
        transition: margin-left .28s;
        margin-left: 180px;
        margin-top: 50px;
        position: relative;
        &.allwidth{
          .TMSFullDialog{
            left: 0;
          }
        }
      }
      .allwidth {
        /*margin-top: 0 !important;*/
        margin-left: 0 !important;
      }
    }
  }
  @import "./less/mainFrame.less";
</style>
